import React from 'react'
import ScroolTop from '../tools/ScroolTop'
import Footer from '../tools/Footer'
import BarHorizontale from '../tools/BarHorizontale'
import DatatableAdmin from '../tools/admin/DatatableAdmin'
import FormAddAdmin from '../tools/admin/FormAddAdmin'

function Admin({users, announcements}) {
  return (
    <>
      <div className="d-flex flex-column" id="content-wrapper">
          <div id="content">
              <BarHorizontale />
              <div className="container-fluid">
                  <h3 className="text-dark mb-4 titre1">Gestion des administrateurs</h3>
                  <div className="row mb-3">
                    <FormAddAdmin />
                    <div className="col-sm-12 col-lg-12">
                      <div className="card shadow">
                          <div className="card-header py-3">
                            <p className="text-primary m-0 fw-bold  titre1">Les administrateurs</p>
                          </div>
                          <div className="card-body">
                            <DatatableAdmin users={users} announcements={announcements}/>
                          </div>
                      </div>
                    </div>                    
                  </div>
              </div>
          </div>
          <Footer/>
      </div>
      <ScroolTop />
    </>
  )
}

export default Admin